// *********************************
// CoolGames Builder JavaScript file
import { tgfSettings } from "../../game_logic/framework/tgfSettings";
// *********************************
export var tgfSettingsOverride = function () {
    "use strict";
    tgfSettings.nakama = {
        // AngryBirds PROD
        key: "wpQouqPv81sYjQSAh5v",
        endpoint: "public.angry-birds.nakama.live.cg-gb.com",
        isProdVersion: true,
        // AngryBirds PROD
        fbAppId: "1825153594465039",
        // AngryBirds PROD
        fbAppToken: "EAAZA796ZBomw8BAGKxfomoHIGepW8d6gB5iZAFs2LMF0RoRrgcFkSgdZCRkgnZBA2cXHBEnfWpqSA7U4ZA6DVT85qFNISrcH7Hqlt4Ttj9qKST6kdZBRWzlTLjEDZAxQJHgeNwUFB73y5Vy92MEnSEWk6bdS6wbMTPGVhR0KYMQYGQZDZD"
    };
    tgfSettings.enableDebugSettings = false;
    tgfSettings.facebook = {
        // AngryBirds PROD
        rewardedVideoPlacementId: "1825153594465039_1838291466484585",
        interstitialPlacementId: "1825153594465039_1935367346776996"
    };
    tgfSettings.analytics = {
        beaconGameKey: "abinstant_3f144221",
        beaconSecretKey: "ifB9NFEmbNwgV3UyFqlWpZ5gA57w/aN1",
        beaconDebugMessages: false
    };
    tgfSettings.matchTurnExpirationTime = (72 * 60 * 60); // in seconds
};
